import SEO from "../components/SEO";
import LandingNav from "../components/landing/LandingNav";
import LandingFooter from "../components/landing/LandingFooter";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <SEO title="Terms & Conditions — hireqix" description="Terms of service for using the hireqix resume screening platform." keywords="hireqix terms of service, resume screener terms, hireqix legal" canonicalPath="/terms" />
      <LandingNav />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <span className="text-xs font-bold uppercase tracking-widest text-primary">Legal</span>
        <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight sm:text-4xl">Terms & Conditions</h1>
        <p className="mt-2 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <Section title="1. Acceptance of Terms">
            By creating a hireqix account you agree to these Terms & Conditions and our Privacy Policy.
          </Section>
          <Section title="2. Credits & Billing">
            New workspaces receive 10 free trial credits (up to 1 job, up to 5 resume evaluations). Additional credits are purchased in packs starting at
            ₹500 and never expire. Each resume evaluation costs 2 credits, deducted at the time of evaluation.
          </Section>
          <Section title="3. Workspace Roles">
            Workspace Admins/Owners can create jobs, manage the competency matrix, invite or remove team members, and purchase credits. Members can upload
            resumes and view evaluation results but cannot modify job setup or team membership.
          </Section>
          <Section title="4. Multi-Batch Data">
            Resumes uploaded in separate sessions are grouped into sequential batches (Batch 1, Batch 2...) per job. Batches are retained indefinitely as
            part of your workspace's job history unless you delete the job.
          </Section>
          <Section title="5. Acceptable Use">
            You agree not to upload resumes you are not authorized to process, and not to use hireqix for any unlawful discriminatory hiring practice.
          </Section>
          <Section title="6. Limitation of Liability">
            AI-generated evaluations are a decision-support tool, not a substitute for human judgment. hireqix is not liable for hiring decisions made
            solely on the basis of AI scores.
          </Section>
          <Section title="7. Changes to These Terms">
            We may update these terms from time to time. Continued use of hireqix after changes constitutes acceptance of the revised terms.
          </Section>
          <Section title="8. Contact">
            Questions about these terms can be sent to support@hireqix.com.
          </Section>
        </div>
      </section>
      <LandingFooter />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-heading text-base font-semibold text-foreground">{title}</h2>
      <p className="mt-1.5">{children}</p>
    </div>
  );
}
